import { Type } from "typebox";
export const CheckLoginStatusResponseSchema = Type.Object({
    username: Type.Optional(Type.String())
});
